<template>
<svg viewBox="0 0 20 20" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-ZhuZi`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M14.0909 2.75H5.90909L5.90909 4.25H14.0909V2.75zM5.90909 2C5.40701 2 5 2.33579 5 2.75V4.25C5 4.66421 5.40701 5 5.90909 5H14.0909C14.593 5 15 4.66421 15 4.25V2.75C15 2.33579 14.593 2 14.0909 2H5.90909zM14.0909 15.75H5.90909L5.90909 17.25H14.0909V15.75zM5.90909 15C5.40701 15 5 15.3358 5 15.75V17.25C5 17.6642 5.40701 18 5.90909 18H14.0909C14.593 18 15 17.6642 15 17.25V15.75C15 15.3358 14.593 15 14.0909 15H5.90909z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M12.1429 0.869565H7.85714V19.1304H12.1429V0.869565ZM7 0V20H13V0H7Z"/></svg>
</template>
<script>

export default {
  name: 'IconZhuZi',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
